export default __webpack_public_path__ + "static/media/cover-default.aacb9aae.jpg";